import IOrganization, {
  IOrganizationEnablement,
} from "models/Organization.model";

export default class Organization implements IOrganization {
  public id: string;

  public name: string;

  public slug: string;

  public defaultWorkspaceGroupId: string;

  public isBlocked: boolean;

  public labels: Record<string, string> | null;

  public programId: string | null;

  public ncaId: string | null;

  public ngcOrgId: string | null;

  public ngcEnablements: IOrganizationEnablement[];

  public constructor(o: IOrganization) {
    this.id = o.id;
    this.name = o.name;
    this.slug = o.slug;
    this.defaultWorkspaceGroupId = o.defaultWorkspaceGroupId;
    this.isBlocked = o.isBlocked || false;
    this.labels = o.labels || null;
    this.programId = o.programId || null;
    this.ncaId = o.nca_id || null;
    this.ngcOrgId = o.ngc_org_id || null;
    this.ngcEnablements = o.ngc_enablements || [];
  }
}
